import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/Medidores.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPenToSquare} from '@fortawesome/free-solid-svg-icons';

const API_URL_CLIENTES = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/clientes` 
  : 'http://localhost:4000/clientes';

  const API_URL_TARIFAS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/tarifas` 
  : 'http://localhost:4000/tarifas';

  const API_URL_MEDIDORES = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/medidores` 
  : 'http://localhost:4000/medidores';

const Medidores = () => {
  const [medidores, setMedidores] = useState([]);
  const [searchCode, setSearchCode] = useState('');
  const [selectedMedidor, setSelectedMedidor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [clientSearch, setClientSearch] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  // Lista de tarifas (puedes obtenerlas desde una API)
  const [tarifas, setTarifas] = useState([]);
  const [newMedidor, setNewMedidor] = useState({
    codigo_medidor: '',
    ubicacion_medidor: '',
    fecha_instalacion: '',
    nombre_medidor: '',
    estado_medidor: '', // Agregado este campo
    id_cliente: '',
    id_tarifa: '',
  });
  

  const [errorMessage, setErrorMessage] = useState('');
  const [existsError, setExistsError] = useState('');

  useEffect(() => {
    fetchMedidores();
  }, []);

  useEffect(() => {
    // Obtener las tarifas disponibles
    const fetchTarifas = async () => {
      try {
        const response = await axios.get(API_URL_TARIFAS); // Ajusta la URL a la ruta de tarifas en tu backend
        setTarifas(response.data); // Almacena las tarifas en el estado
      } catch (error) {
        console.error('Error fetching tarifas:', error);
      }
    };

    fetchTarifas();
  }, []);

  useEffect(() => {
    if (searchCode) {
      fetchMedidorByCode(searchCode);
    } else {
      fetchMedidores();
    }
  }, [searchCode]);

  const fetchMedidores = async () => {
    try {
      const response = await axios.get(API_URL_MEDIDORES);
      // Ordenar los medidores por la fecha de instalación, de más reciente a más antigua
      const sortedMedidores = response.data.sort((a, b) => new Date(b.fecha_instalacion) - new Date(a.fecha_instalacion));
      setMedidores(sortedMedidores); // Guardar los medidores ordenados en el estado
    } catch (error) {
      console.error('Error fetching medidores data:', error);
    }
  };
  

  const fetchMedidorByCode = async (codigo) => {
    try {
      const response = await axios.get(`${API_URL_MEDIDORES}/codigo/${codigo}`);
      setMedidores([response.data]);  // Esto debería actualizar solo los medidores encontrados
    } catch (error) {
      console.error('Error fetching medidor data:', error);
    }
  };

  const fetchClientByCode = async (codigo_cliente) => {
    try {
      const response = await axios.get(`${API_URL_CLIENTES}/codigo/${codigo_cliente}`);
      if (response.data) {
        setSelectedClient(response.data);
        setNewMedidor({ ...newMedidor, id_cliente: response.data.id_cliente });
        setErrorMessage('');
        setExistsError('');
      } else {
        setSelectedClient(null);
        setErrorMessage('Ingrese un usuario válido');
      }
    } catch (error) {
      console.error('Error fetching client data:', error);
      setErrorMessage('Usuario no está registrado o es incorrecto');
    }
  };

const handleSearch = (e) => {
  e.preventDefault();
  if (searchCode) {
    fetchMedidorByCode(searchCode);  // Solo buscar por código si se ingresa algo
  } else {
    fetchMedidores();  // Si no hay búsqueda, mostrar todos los medidores
  }
};


  const handleEdit = (medidor) => {
    setSelectedMedidor(medidor);
  };

  const handleDelete = (medidor) => {
    setSelectedMedidor(medidor); // Guarda el medidor seleccionado para la eliminación
    setShowDeleteConfirm(true); // Muestra el modal de confirmación
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_URL_MEDIDORES}/codigo/${selectedMedidor.codigo_medidor}`);
      fetchMedidores();
      setShowDeleteConfirm(false); // Cierra el modal de confirmación
    } catch (error) {
      console.error('Error deleting medidor:', error);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false); // Cierra el modal de confirmación sin eliminar
  };

  const checkMedidorExists = async (codigo_medidor) => {
    try {
      const response = await axios.get(`${API_URL_MEDIDORES}/codigo/${codigo_medidor}`);
      return response.status === 200; // El medidor existe si se recibe un estado 200
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return false; // El medidor no existe si se recibe un estado 404
      }
      console.error('Error checking if medidor exists:', error);
      return false;
    }
  };
  const handleAddMedidor = async (e) => {
    e.preventDefault();
  
    const {
      codigo_medidor,
      ubicacion_medidor,
      fecha_instalacion,
      nombre_medidor,
      estado_medidor,
      id_cliente,
      tipo_tarifa,
    } = newMedidor;
  
    // Validación de campos vacíos
    if (
      !codigo_medidor ||
      !ubicacion_medidor ||
      !fecha_instalacion ||
      !nombre_medidor ||
      !estado_medidor ||
      !id_cliente ||
      !tipo_tarifa
    ) {
      setErrorMessage('Por favor, complete todos los campos obligatorios.');
      return;
    }
  
    try {
      // Envío de datos al backend
      await axios.post(API_URL_MEDIDORES, newMedidor);
  
      // Actualizar la lista de medidores y cerrar el modal
      fetchMedidores();
      handleCloseModal();
      setErrorMessage(''); // Limpiar mensajes de error si la operación es exitosa
    } catch (error) {
      // Manejar errores del servidor
      if (error.response) {
        if (error.response.status === 409) {
          setErrorMessage('El medidor ya está registrado.');
        } else {
          setErrorMessage('El medidor ya está registrado o es incorrecto.');
        }
      } else {
        setErrorMessage('Error al conectar con el servidor.');
      }
    }
  };
   

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedClient(null);
    setNewMedidor({
      codigo_medidor: '',
      ubicacion_medidor: '',
      fecha_instalacion: '',
      nombre_medidor: '',
      estado_medidor: 'activo', // Valor por defecto
      id_cliente: '',
      id_tarifa: '', // Tarifa seleccionada
    });
    setErrorMessage('');
    setExistsError('');
  };

  const handleClientSearch = (e) => {
    e.preventDefault();
    fetchClientByCode(clientSearch);
  };

  const handleOpenEditModal = (medidor) => {
    setSelectedMedidor(medidor);
    setShowEditModal(true);
  };
  
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedMedidor(null);
  };

const handleClientSearchForEdit = async (e) => {
  e.preventDefault();

  if (clientSearch) {
    try {
      const response = await axios.get(`${API_URL_CLIENTES}/codigo/${clientSearch}`);
      if (response.data) {
        setSelectedClient(response.data);
        setSelectedMedidor({ ...selectedMedidor, id_cliente: response.data.id_cliente });
        setErrorMessage('');
        setExistsError('');
      } else {
        setSelectedClient(null);
        setErrorMessage('Código de cliente no válido.');
      }
    } catch (error) {
      console.error('Error fetching client data:', error);
      setErrorMessage('Error al buscar el cliente.');
    }
  } else {
    setErrorMessage('Ingrese un código de cliente para buscar.');
    setSelectedClient(null);
  }
};

const handleUpdateMedidor = async (e) => {
  e.preventDefault();
  if (!selectedMedidor) return;

  try {
    // Actualiza el medidor con el id_cliente seleccionado
    await axios.put(`${API_URL_MEDIDORES}/codigo/${selectedMedidor.codigo_medidor}`, {
      ...selectedMedidor,
      id_cliente: selectedMedidor.id_cliente, // Asegúrate de incluir el id_cliente
    });
    fetchMedidores(); // Actualiza la lista de medidores
    handleCloseEditModal(); // Cierra el modal de edición
  } catch (error) {
    console.error('Error updating medidor:', error);
    setErrorMessage('No se pudo actualizar el medidor.');
  }
};

// Abrir modal de edición
const handleEditClick = (medidor) => {
  setSelectedMedidor(medidor); // Cargar los datos del medidor seleccionado
  setShowEditModal(true); // Mostrar el modal de edición
};


  return (
    <div className="medidores-panel">
      <div className="header-buttons">
        <Button variant="primary" onClick={handleOpenModal}>+ Nuevo Medidor</Button>
      </div>

      <h2>Gestión de Medidores</h2>

      <Form onSubmit={handleSearch} className="search-form">
        <Form.Control
          type="text"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value)}
          placeholder="Buscar por código del medidor"
        />
        <Button variant="secondary" type="submit">Buscar</Button>
      </Form>
      <div className="medidores-panel1"> 
      <table className="medidores-table">
        <thead>
          <tr>
            <th>Código Conexion</th>
            <th>Nombre Cliente</th>
            <th>Ubicación</th>
            <th>Fecha de Instalación</th>
            <th>Nombre Medidor</th>
            <th>Estado Medidor</th>
            <th>Tipo Medidor</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {medidores.map((medidor) => (
            <tr key={medidor.codigo_medidor}>
              <td>{medidor.codigo_medidor}</td>
              <td>{medidor.cliente?.nombre_cliente || 'Desconocido'}</td>
              <td>{medidor.ubicacion_medidor}</td>
              <td>{new Date(medidor.fecha_instalacion).toLocaleDateString()}</td>
              <td>{medidor.nombre_medidor}</td>
              <td>{medidor.estado_medidor}</td>
              <td>{medidor.tarifa?.tipo_tarifa }</td>
              <td className="button-container">
                <Button variant="success" className="action-button" onClick={() => handleOpenEditModal(medidor)}><FontAwesomeIcon icon={faPenToSquare} /></Button>
                <Button variant="danger" className="action-button delete-button" onClick={() => handleDelete(medidor)}><FontAwesomeIcon icon={faTrash} /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {/* Modal para agregar un nuevo medidor */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Medidor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleClientSearch} className="client-search-form">
            <Form.Group>
              <Form.Label>Cédula del Cliente</Form.Label>
              <Form.Control
                type="text"
                value={clientSearch}
                onChange={(e) => setClientSearch(e.target.value)}
                placeholder="Buscar por cédula de cliente"
              />
              <br />
              <Button variant="secondary" type="submit">Buscar Cliente</Button>
            </Form.Group>
          </Form>

          {/* Mostrar mensajes de error */}
          {errorMessage && (
            <div className="alert alert-danger mt-3">
              {errorMessage}
            </div>
          )}
          {existsError && (
            <div className="alert alert-danger mt-3">
              {existsError}
            </div>
          )}

          {selectedClient && (
            <div className="client-info">
              <p><strong>Cliente:</strong> {selectedClient.nombre_cliente}</p>
            </div>
          )}

          <Form onSubmit={handleAddMedidor} className="medidor-form">
            <Form.Group>
              <Form.Label>Código del Medidor</Form.Label>
              <Form.Control
                type="text"
                value={newMedidor.codigo_medidor}
                onChange={(e) => setNewMedidor({ ...newMedidor, codigo_medidor: e.target.value })}
                required
                disabled={!selectedClient}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Ubicación</Form.Label>
              <Form.Control
                type="text"
                value={newMedidor.ubicacion_medidor}
                onChange={(e) => setNewMedidor({ ...newMedidor, ubicacion_medidor: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Fecha de Instalación</Form.Label>
              <Form.Control
                type="date"
                value={newMedidor.fecha_instalacion}
                onChange={(e) => setNewMedidor({ ...newMedidor, fecha_instalacion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Nombre del Medidor</Form.Label>
              <Form.Control
                type="text"
                value={newMedidor.nombre_medidor}
                onChange={(e) => setNewMedidor({ ...newMedidor, nombre_medidor: e.target.value })}
              />
            </Form.Group>
            
            <Form.Group controlId="tipo_tarifa">
              <Form.Label>Tipo de Tarifa</Form.Label>
              <Form.Control
                as="select"
                value={newMedidor.tipo_tarifa} // Enlazamos con el estado correspondiente
                onChange={(e) => setNewMedidor({ ...newMedidor, tipo_tarifa: e.target.value })}
                required
              >
                <option value="">Seleccione un tipo de tarifa</option>
                {tarifas.map((tarifa) => (
                  <option key={tarifa.id_tarifa} value={tarifa.tipo_tarifa}>
                    {tarifa.tipo_tarifa}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            
            <Form.Group controlId="estado_medidor">
              <Form.Label>Estado del Medidor</Form.Label>
              <Form.Control
                as="select"
                value={newMedidor.estado_medidor} // Enlazamos con el estado correspondiente
                onChange={(e) => setNewMedidor({ ...newMedidor, estado_medidor: e.target.value })}
                required
              >
                <option value="">Seleccione un estado</option>
                <option value="activo">Activo</option>
                <option value="suspendido">Suspendido</option>
              </Form.Control>
            </Form.Group>
            <Form.Group> <br />
              <Button variant="primary" type="submit">
                Agregar Medidor
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>

{/* Modal para editar un medidor */}
<Modal show={showEditModal} onHide={handleCloseEditModal}>
  <Modal.Header closeButton>
    <Modal.Title>Editar Medidor</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Formulario para editar */}
    <Form onSubmit={handleUpdateMedidor} className="edit-medidor-form">
      <Form.Group>
        <Form.Label>Código del Medidor</Form.Label>
        <Form.Control
          type="text"
          value={selectedMedidor?.codigo_medidor || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, codigo_medidor: e.target.value })}
          required
          disabled // El código no se puede editar
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Ubicación</Form.Label>
        <Form.Control
          type="text"
          value={selectedMedidor?.ubicacion_medidor || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, ubicacion_medidor: e.target.value })}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Fecha de Instalación</Form.Label>
        <Form.Control
          type="date"
          value={selectedMedidor?.fecha_instalacion || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, fecha_instalacion: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Nombre del Medidor</Form.Label>
        <Form.Control
          type="text"
          value={selectedMedidor?.nombre_medidor || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, nombre_medidor: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group controlId="tipo_tarifa">
        <Form.Label>Tipo de Tarifa</Form.Label>
        <Form.Control
          as="select"
          value={selectedMedidor?.tipo_tarifa || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, tipo_tarifa: e.target.value })}
          required
        >
          <option value="">Seleccione un tipo de tarifa</option>
          {tarifas.map((tarifa) => (
            <option key={tarifa.id_tarifa} value={tarifa.tipo_tarifa}>
              {tarifa.tipo_tarifa}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      <Form.Group controlId="estado_medidor">
        <Form.Label>Estado del Medidor</Form.Label>
        <Form.Control
          as="select"
          value={selectedMedidor?.estado_medidor || ''}
          onChange={(e) => setSelectedMedidor({ ...selectedMedidor, estado_medidor: e.target.value })}
          required
        >
          <option value="">Seleccione un estado</option>
          <option value="activo">Activo</option>
          <option value="suspendido">Suspendido</option>
        </Form.Control>
      </Form.Group>


            <Form.Group> <br />
              <Button variant="primary" type="submit">
                Guardar Cambios
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>


      {/* Modal de confirmación de eliminación */}
      <Modal show={showDeleteConfirm} onHide={cancelDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres eliminar este medidor?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Eliminar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Medidores;